var map = {
	"./aks-black.svg": "d913",
	"./aks.svg": "1c1b",
	"./aliyun-black.svg": "b3306",
	"./aliyun.svg": "4f5b",
	"./aliyunecs-black.svg": "113b",
	"./aliyunecs.svg": "f11b",
	"./amazonec2-black.svg": "6c8f",
	"./amazonec2.svg": "e8c61",
	"./amazoneks-black.svg": "abf6",
	"./amazoneks.svg": "2929",
	"./aws.svg": "7c2c",
	"./azure-black.svg": "d676",
	"./azure.svg": "5a2e",
	"./azuread-black.svg": "01ce",
	"./azuread.svg": "2acd",
	"./azureaks-black.svg": "f5c5",
	"./azureaks.svg": "58f9",
	"./baidu-black.svg": "952b",
	"./baidu.svg": "d339",
	"./cloudca-black.svg": "0545",
	"./cloudca.svg": "0f54",
	"./cloudscale-black.svg": "2bcb",
	"./cloudscale.svg": "b1f4",
	"./custom.svg": "b014",
	"./digitalocean-black.svg": "23e0",
	"./digitalocean.svg": "7a5f",
	"./equinix-black.svg": "6387",
	"./equinix.svg": "3a7f",
	"./exoscale.svg": "3d36",
	"./gcp.svg": "449d",
	"./gke-black.svg": "93ec",
	"./gke.svg": "ae7b",
	"./google.svg": "1d1f",
	"./googlegke-black.svg": "03bc",
	"./googlegke.svg": "9681",
	"./harvester.svg": "b0eb",
	"./huaweicce-black.svg": "f19c",
	"./huaweicce.svg": "fd9e",
	"./import.svg": "9cbc",
	"./k3s-black.svg": "6146",
	"./k3s.svg": "f4c4",
	"./kubernetes-black.svg": "db05",
	"./kubernetes.svg": "1722",
	"./linode.svg": "808a",
	"./linodelke-black.svg": "9c2d",
	"./linodelke.svg": "b011",
	"./local-cluster.svg": "05dd",
	"./minikube-black.svg": "9932",
	"./minikube.svg": "110a",
	"./nutanix.svg": "9536",
	"./oci-black.svg": "eb0f",
	"./oci.svg": "140a",
	"./openstack-black.svg": "379a",
	"./openstack.svg": "1965",
	"./oracle.svg": "bb2a",
	"./oracleoke-black.svg": "fd82",
	"./oracleoke.svg": "f881",
	"./otc-black.svg": "c56d",
	"./otc.svg": "8a1d2",
	"./otccce.svg": "db6d",
	"./outscale.svg": "bffb",
	"./packet-black.svg": "ec30",
	"./packet.svg": "fced",
	"./pinganyunecs-black.svg": "1f7f",
	"./pinganyunecs.svg": "1d3a",
	"./pnap-black.svg": "e4ee",
	"./pnap.svg": "6800",
	"./rackspace-black.svg": "a03a",
	"./rackspace.svg": "bf29",
	"./rke.svg": "f6c8",
	"./rke2.svg": "7672",
	"./softlayer.svg": "775a",
	"./tencenttke-black.svg": "f63f",
	"./tencenttke.svg": "c0b6",
	"./vmwarevsphere-black.svg": "33ec",
	"./vmwarevsphere.svg": "438c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5ffc";